/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Delete_ReassignInputs */

const cs_settings_teams_delete_reassign = /** @type {(inputs: Settings_Teams_Delete_ReassignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout lidi do`)
};

const en_settings_teams_delete_reassign = /** @type {(inputs: Settings_Teams_Delete_ReassignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reassign people to`)
};

/**
* | output |
* | --- |
* | "Reassign people to" |
*
* @param {Settings_Teams_Delete_ReassignInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_delete_reassign = /** @type {((inputs?: Settings_Teams_Delete_ReassignInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Delete_ReassignInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_delete_reassign(inputs)
	return cs_settings_teams_delete_reassign(inputs)
});